// extracted by mini-css-extract-plugin
export default {"root":"AuthenticatedLayout_root__UPdL8","content":"AuthenticatedLayout_content__zArT6"};